import React, { useCallback } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { usePickupSettingsContext, usePickupSettingsContextTypes } from '../contexts/pickup-settings-context';
import { useEditShipFromModalContext } from '../contexts/edit-ship-from-modal-context-provider';

import messages from '../messages';
import style from '../style.module.less';
import { trackShipFromEditButtonClick } from '../../../../ship-from/tracking-events';
import { EventSourceStrings } from '../../../../tracking/tracking-constants';

const ShipFromOrigin = () => {
  usePickupSettingsContextTypes('ShipFromOrigin');
  const { shipFrom } = usePickupSettingsContext();
  const { setEditShipFromId } = useEditShipFromModalContext();
  const onClickEditShipFrom = useCallback(() => {
    trackShipFromEditButtonClick(shipFrom.shipFromId, EventSourceStrings.SETTINGS_SHIP_FROM_LOCATIONS);
    setEditShipFromId(shipFrom.shipFromId);
  }, [setEditShipFromId, shipFrom?.shipFromId]);

  const { name: originName, company, line1, line2, city, state, postalCode, phone, phoneNumberExtension } = shipFrom?.originAddress || {};

  return (
    <>
      <h3 className={classnames(style.title, style.warehouse)}>{shipFrom?.name}</h3>
      <div>{originName}</div>
      {!!company && <div>{company}</div>}
      <div>{line1}</div>
      <div>{line2}</div>
      <div>
        {city}
        {!!state && `, ${state}`} {postalCode}
      </div>
      <div>
        {phone} {phoneNumberExtension}
      </div>
      <Button className={style.link} onClick={onClickEditShipFrom} theme='link'>
        <FormattedMessage {...messages.editShipFromLocation} />
      </Button>
    </>
  );
};

export default ShipFromOrigin;
